<template>
  <div class="bg-white lg:border-0.5 p-3 rounded-md max-w-max">
    <div class="flex items-center gap-5">
      <progress-circle
        class=""
        :completed-steps="sections.length"
        :total-steps="sections.length"
        start-color="#DEA42C"
        stop-color="#DEA42C"
        circle-color="#E6E4E4"
      >
        <p class="text-xl font-bold">
          {{ (sections.length / sections.length) * 100 }}%
        </p>
      </progress-circle>
      <div>
        <p class="lg:text-lg font-bold">
          Your organization setups are incomplete
        </p>
        <div class="lg:grid grid-cols-2 gap-2">
          <div
            v-for="(section, index) in sections"
            :key="section + index"
            class="flex items-center text-sm gap-2 grayscale"
          >
            <img class="h-4 object-contain" src="@/assets/icons/check.png" />
            <p>{{ section }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProgressCircle } from "vue-progress-circle";
export default {
  name: "SetupCompletion",
  components: { ProgressCircle },
  data() {
    return {
      sections: [
        "Core Setups",
        "Core Setups",
        "Benefits Setup",
        "Documents Setups",
        "Assets Setups",
        "Time Off Setups",
      ],
    };
  },
};
</script>
